import { useState, useEffect, useRef } from 'react';
function usePassengerInformationFormStep1(
  savePNR,
  userDetail,
  location,
  dataToEdit,
) {
  const [openList, setopenList] = useState(false)
  const [currentPassenger, setCurrentPassenger] = useState(0);
  const [isBtnPrevious, setIsBtnPrevious] = useState(false);
  const refSelectList = useRef();
  const [isBtnNext, setIsBtnNext] = useState(false);
  const [inputError, setInputError] = useState([]);
  const [listOfForms, setListOfForms] = useState([]);


  console.log("currentPassenger? ", currentPassenger)
  const typesPassenger = {
    adult: { text: 'Adulto', id: 'ADT', },
    boy: { text: 'Infante', id: 'CHD', },
    baby: { text: 'Bebé', id: 'SEAT', },
    contact: { text: 'Contacto', id: 'CONTACT' },
  }

  const regexList = {
    name: /^[A-Za-z\s']+$/,
    lastName: /^[A-Za-z\s']+$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    birth: /^\d{4}-\d{2}-\d{2}$/,
  }

  function buildListOfForms() {
    const adults = location?.passengersSelected?.adult;
    const boys = location?.passengersSelected?.boy;
    const babys = location?.passengersSelected?.baby;
    const newArray = [];
    let obj;
    for (let a = 1; a <= adults; a++) {
      obj = {
        key: `${typesPassenger?.adult?.text} ${a}`,
        type: typesPassenger?.adult?.id,
        name: '',
        lastName: '',
        documentNumber: '',
        gender: '',
        birth: ''
      }
      newArray.push(obj)
    }
    for (let c = 1; c <= boys; c++) {
      obj = {
        key: `${typesPassenger?.boy?.text} ${c}`,
        type: typesPassenger?.boy?.id,
        name: '',
        lastName: '',
        documentNumber: '',
        gender: '',
        birth: ''
      }
      newArray.push(obj)
    }
    for (let b = 1; b <= babys; b++) {
      obj = {
        key: `${typesPassenger?.baby?.text} ${b}`,
        type: typesPassenger?.baby?.id,
        name: '',
        lastName: '',
        documentNumber: '',
        gender: '',
        birth: '',
        offspring: false,
      }
      newArray.push(obj)
    }
    obj = {
      key: typesPassenger?.contact?.text,
      type: typesPassenger?.contact?.id,
      // name: '',
      // lastName: '',
      // documentNumber: '',
      email: '',
      codePhone: '',
      numberPhone: '',
      // address: ''
    }
    newArray.push(obj)
    setListOfForms(newArray);
  }

  function getFormPassenger(event) {
    const value = event?.target?.value;
    const key = event?.target?.id;
    const currentKey = listOfForms[currentPassenger].key;
    const regex = regexList[key];
    const newError = { id: key, message: event.target.name }
    const errorClear = inputError.filter((obj) => obj.id !== key)
    const errorExists = inputError.find((obj) => obj.id === key);

    if (regex) {
      const validation = regex.test(value)
      if (!validation) {
        if (!errorExists) {
          setInputError(prevObjetos => [...prevObjetos, newError]);
        }
      }
      else if (errorExists) {
        setInputError([...errorClear])
      }
      if (value === '') {
        setInputError(errorClear)
      }
      // if (key === 'birth') {
      //   let rangeAproved
      //   const currentType = listOfForms[currentPassenger]?.type;
      //   const userYear = parseInt(value.split('-')[0]);
      //   const userMonth = parseInt(value.split('-')[1]);
      //   const userDay = parseInt(value.split('-')[2]);
      //   const nowYear = new Date().getFullYear();
      //   const nowMonth = new Date().getMonth() + 1;
      //   const nowDay = new Date().getDate();
      //   rangeAproved = false;
      //   console.log("evaluar a ", value, 'segun ', currentType)
      //   const yearsDiff = nowDate.getFullYear() - userDate.getFullYear();
      //   const monthsDiff = nowDate.getMonth() - userDate.getMonth();
      //   const daysDiff = nowDate.getDate() - userDate.getDate();
      //   console.log('yd',yearsDiff )
      //   console.log('md',monthsDiff)
      //   console.log('dd',daysDiff )
      // rangeAproved ? setInputError([...errorClear]) : setInputError(prevObjetos => [...prevObjetos, newError]);
      // }
    }
    setFormPassenger(value, key)
  }

  function setFormPassenger(value, key) {
    const currentKey = listOfForms[currentPassenger].key;
    setListOfForms(prevObjetos => {
      const updatedObjetos = prevObjetos.map(obj => {
        if (obj?.key === currentKey) {
          return { ...obj, [key]: value };
        }
        return obj;
      });
      return updatedObjetos;
    });
  }

  function buildInputs() {
    const inputsListFormatter = {
      name: {
        title: 'Nombres',
        label: 'Como figura en el documento',
        required: true,
        id: 'name',
        type: 'text',
        value: listOfForms[currentPassenger]?.name,
        placeHolder: 'Como figura en el documento',
        func: getFormPassenger,
        name: 'El nombre no es valido',
      },
      lastName: {
        title: 'Apellidos',
        label: 'Como figura en el documento',
        required: true,
        id: 'lastName',
        type: 'text',
        value: listOfForms[currentPassenger]?.lastName,
        placeHolder: 'Como figura en el documento',
        func: getFormPassenger,
        name: 'El apellido no es valido',
      },
      documentNumber: {
        title: 'Número de documento',
        label: 'Como figura en el documento',
        required: true,
        id: 'documentNumber',
        type: 'text',
        value: listOfForms[currentPassenger]?.documentNumber,
        placeHolder: 'Como figura en el documento',
        func: getFormPassenger,
        name: 'El número no es valido',
      },
      gender: {
        title: 'Genero',
        label: 'Como figura en el documento',
        required: true,
        id: 'gender',
        type: 'select',
        value: listOfForms[currentPassenger]?.gender,
        placeHolder: 'Seleccionar genero',
        func: setFormPassenger,
        name: 'El número no es valido',
        optionsList: ['Masculino', 'Femenino']
      },
      birth: {
        title: 'Fecha de nacimiento',
        label: 'dia / mes / año',
        required: true,
        id: 'birth',
        type: 'date',
        value: listOfForms[currentPassenger]?.birth,
        placeHolder: 'Seleccionar fecha de nacimiento',
        func: getFormPassenger,
        name: 'La fecha no es valida',
        optionsList: ['Masculino', 'Femenino'],
      },
      email: {
        title: 'Email',
        label: 'Correo electrónico',
        required: true,
        id: 'email',
        type: 'email',
        value: listOfForms[currentPassenger]?.email,
        placeHolder: 'email',
        func: getFormPassenger,
        name: 'El email no es valida',
      },
      codePhone: {
        title: 'Código de país',
        label: 'Código de país',
        required: true,
        id: 'codePhone',
        type: 'number',
        value: listOfForms[currentPassenger]?.codePhone,
        placeHolder: '+57',
        func: getFormPassenger,
        name: 'El número no es valid0',
      },
      numberPhone: {
        title: 'Número telefónico',
        label: 'Número telefónico',
        required: true,
        id: 'numberPhone',
        type: 'number',
        value: listOfForms[currentPassenger]?.numberPhone,
        placeHolder: '000 00 00',
        func: getFormPassenger,
        name: 'El número no es valid0',
      },
      address: {
        title: 'Dirección',
        label: 'Dirección de contacto',
        required: true,
        id: 'address',
        type: 'text',
        value: listOfForms[currentPassenger]?.address,
        placeHolder: 'Dirección',
        func: getFormPassenger,
        name: 'La dirección no es valida',
      },
      offspring: {
        title: 'offspring',
        label: 'offspring',
        required: true,
        id: 'offspring',
        type: 'offspring',
        value: listOfForms[currentPassenger]?.offspring,
        placeHolder: 'offspring',
        func: getFormPassenger,
        name: 'Offspring no es valido',
      },
    };

    const inputsPassenger = [
      inputsListFormatter.name,
      inputsListFormatter.lastName,
      inputsListFormatter.documentNumber,
      inputsListFormatter.gender,
      inputsListFormatter.birth,
    ]
    const inputsContact = [
      // inputsListFormatter.name,
      // inputsListFormatter.lastName,
      // inputsListFormatter.documentNumber,
      inputsListFormatter.email,
      inputsListFormatter.codePhone,
      inputsListFormatter.numberPhone,
      // inputsListFormatter.address
    ]

    const isTheLast = listOfForms[currentPassenger]?.key === typesPassenger.contact.text
    return isTheLast ? inputsContact : inputsPassenger;
  }

  const inputsList = buildInputs();

  function selectCurrentPassenger(value) {
    const newValue = currentPassenger + value;
    if (newValue >= 0 && newValue <= listOfForms.length) {
      setCurrentPassenger(newValue);
    }
  }


  function validarCampos(campos) {
    for (let campo in campos) {
      if (campos.hasOwnProperty(campo) && campos[campo] === '') {
        return false;
      }
    }
    return true;
  };


  function getInputError(input) {
    let res = false
    if (inputError.length > 0) {
      for (const e in inputError) {
        const error = inputError[e]
        if (error.id === input?.id) {
          res = error;
          break;
        }
      }
    }
    return res;
  }

  /* *********************** init *********************** */



  //function que retorna este formato: "----10SEP98-M--"
  function buildFree(value) {
    const fecha = new Date(value?.birth);
    const nameMonth = fecha.toLocaleString('default', { month: 'long' }).toLocaleUpperCase();
    const dayBirth = value?.birth?.split('-')[2];
    const monthBirth = nameMonth.substring(0, 3);
    const year = value?.birth?.split('-')[0]
    const yearBirth = year?.substring(year.length - 2);
    const genderInitial = value?.gender?.charAt(0)?.toLocaleUpperCase();
    const res = `----${dayBirth}${monthBirth}${yearBirth}-${genderInitial}--`;
    return res;
  }

  //function que inserta un baby en un adult disponible
  function insertBaby(baby, tree) {
    const adultSingle = tree.find((obj) => obj.passengerType === typesPassenger.adult.id && !obj.hasOwnProperty('baby'))
    const newBaby = baby;
    newBaby.offspring = false

    delete newBaby.passengerType;
    delete newBaby.number;

    adultSingle.baby = newBaby;
    return tree;
  }

  // function para obtener el precio segun rol del pasajero
  function getPrice(type) {
    let res;
    const types = [
      { type: typesPassenger.adult.id, code: 'ADT' },
      { type: typesPassenger.boy.id, code: 'CH' },
      { type: typesPassenger.baby.id, code: 'INF' },
    ];
    const data = types.find((obj) => obj.type === type);
    if (data) {
      const response = location?.prices.find((res) => res.type === data.code);
      res = response?.price;
    }
    return res
  }

  function buildData() {
    let travellers = [];
    for (const l in listOfForms) {
      const obj = listOfForms[l];
      const n = parseInt(l);
      const number = n + 1;
      const data = {
        key: obj?.key,
        number: number,
        free: buildFree(obj),
        name: obj?.name,
        lastName: obj?.lastName,
        passengerType: obj?.type,
        birth: obj?.birth,
        gender: obj?.gender,
        documentNumber: obj?.documentNumber,
        price: getPrice(obj?.type),
      }
      if (data?.passengerType !== typesPassenger?.contact?.id) {
        if (data?.passengerType === typesPassenger?.baby?.id) {
          const response = insertBaby(data, travellers)
          travellers = response
        }
        else {
          travellers.push(data);
        }
      }
    }
    const user = listOfForms.find((obj) => obj?.type === typesPassenger?.contact?.id);
    const dataPNR = {
      user_id: userDetail?.id,
      company: location?.company,
      bag: location?.bag,
      fare: location?.fare,
      itinerary: location?.itinerary,
      tel: user?.numberPhone,
      email: user?.email.replace('@', '//'),
      emailTwo: user?.email,
      travellers: travellers,
    };
    console.log("dataPNR: ", dataPNR)
    savePNR(dataPNR);
  }


 



  /* *********************** end *********************** */
  useEffect(() => {
    const formCompleted = validarCampos(listOfForms[currentPassenger]);
    const response = formCompleted && inputError.length === 0;
    setIsBtnNext(response);
  }, [listOfForms, currentPassenger])

  useEffect(() => {
    setIsBtnPrevious(currentPassenger !== 0);
  }, [currentPassenger]);

  useEffect(() => {
  console.log("dataToEdit???????", dataToEdit)
    if(dataToEdit){
      const selected = listOfForms.find((obj)=> obj?.key === dataToEdit?.key)
      const position = listOfForms.findIndex((element) => element === selected);
      console.log("position: ", position)
      setCurrentPassenger(position);
    }
  }, [dataToEdit])

  useEffect(() => {
    buildListOfForms();

    

    function handleClickOutside(event) {
      if (refSelectList.current && !refSelectList.current.contains(event.target)) {
        setopenList(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [])

  return {
    listOfForms,
    openList,
    setopenList,
    currentPassenger,
    setCurrentPassenger,
    validarCampos,
    isBtnPrevious,
    isBtnNext,
    selectCurrentPassenger,
    buildData,
    inputsList,
    refSelectList,
    getInputError

  }
}

export default usePassengerInformationFormStep1;
